import { exists } from '~/utils'

export const insertLineBreakEveryNumberOfCharacters = (
  text: number | string,
  numberOfCharacters: number,
): string => {
  const textAsString = `${text}`
  const regex = new RegExp(`.{1,${numberOfCharacters}}`, 'g')
  const textSegments = textAsString.match(regex)

  if (!exists(textSegments) || textSegments.length === 0) {
    return ''
  }

  return textSegments.join('\n')
}
